import styled from "styled-components";

export const QuickPaymentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
`;

export const QuickPaymentTitle = styled.h5`
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #5d4deb;
`;

export const WalletSeparator = styled.p`
  margin: 0;
  padding-top: 16px;
  border-top: 1px solid rgba(210, 210, 210, 0.5);
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #5e5e5e;
  text-align: center;
`;
